import type { YMap, YMapContext } from '@yandex/ymaps3-types'

import { h, createApp } from 'vue'

import HintComponent from '@/modules/YandexMap3Module/components/YandexMap3Hint/index.vue'

function createHint(context: YMapContext<unknown>) {
    class HintWindow extends ymaps3.YMapComplexEntity<{}> {
        private _element: HTMLDivElement
        private _detachDom: () => void
        private _unwatchSearchContext: () => void
    
        _createElement() {
            const windowElement = document.createElement('div')
            
            const app = createApp({
                render: () => h(HintComponent),
            })
        
            app.mount(windowElement)

            return windowElement
        }
    
        _searchContextListener() {
            const hintContext = this._consumeContext<{hint: {title: string; text: string}}>(context)?.hint

            if (this._element) {
                const titleElement = this._element.querySelector('.yandex-map-3-hint__title')
                const textElement = this._element.querySelector('.yandex-map-3-hint__text')

                if (titleElement) {
                    titleElement.textContent = hintContext?.title || null
                }

                if (textElement) {
                    textElement.textContent = hintContext?.text || null
                }
            }
        }
    
        protected _onAttach(): void {
            this._element = this._createElement()
            this._unwatchSearchContext = this._watchContext(context, this._searchContextListener.bind(this))
            this._detachDom = ymaps3.useDomContext(this, this._element, this._element)
        }
    
        protected _onDetach(): void {
            this._unwatchSearchContext()
            this._detachDom()
        }
    }

    return HintWindow
}

export async function addHintToMap(map: YMap) {
    const { YMapHint, YMapHintContext } = await ymaps3.import('@yandex/ymaps3-hint@0.0.1')
    const HintWindow = await createHint(YMapHintContext)

    const hint = new YMapHint({ hint: (object) => object?.properties?.hint })
    map.addChild(hint)

    hint.addChild(new HintWindow({}))
}

export default {
    addHintToMap
}